
  var _styles = {
  "notice-popup-card": {
    "width": "7.52rem",
    "height": "6.82667rem",
    "borderRadius": "0.48rem",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "position": "relative"
  },
  "notice-popup-title": {
    "marginTop": "2.22667rem",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.82667rem",
    "textAlign": "center"
  },
  "notice-popup-description": {
    "marginTop": "0.09333rem",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "textAlign": "center"
  },
  "notice-popup-button": {
    "width": "6.70667rem",
    "height": "1.2rem",
    "borderRadius": "7.45333rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "marginTop": "1.13333rem"
  },
  "notice-popup-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.48rem",
    "lineHeight": "0.64rem"
  },
  "notice-popup-close-btn": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  }
};



  module.exports = _styles;
  